import { useEffect, useState } from 'react';

import { getTilePath } from '../utils/mapFiles';

export const useTileLayer = () => {
  const [tilePath, setTilePath] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    getTilePath()
      .then(path => {
        if (isMounted) {
          setTilePath(path);
        }
      })
      .catch(error => {
        console.error('Failed to load map tiles', error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return tilePath;
};